import { gql } from 'apollo-boost';

export const ruleTriggers = gql`
query {
  ruleTriggers {
    dbId
    name
    status
  }
}
`;
